import { IQuotePaymentTermCodeServiceMock } from './quote-payment-term-code.mock.types';

export const mockQuotePaymentTermCodeService = (): IQuotePaymentTermCodeServiceMock => ({
  fetchQuotePaymentTermCodes: jest.fn(),

  fetchQuotePaymentTermCode: jest.fn()
});
